import { BackgroundJobKindEnum } from 'graphql-common';
import { TFunction } from 'i18next';

const getJobTitle = (
  kind: BackgroundJobKindEnum | null,
  t: TFunction,
): string => {
  const titles: Record<BackgroundJobKindEnum, string> = {
    [BackgroundJobKindEnum.QrCodeGeneration]: t('generating-qr-codes'),
    [BackgroundJobKindEnum.TimelineReport]: t('generating-report'),
    [BackgroundJobKindEnum.DataImport]: t('importing-records'),
    [BackgroundJobKindEnum.DocumentationImport]: t('importing-records'),
    [BackgroundJobKindEnum.DocumentationFieldDetection]: t('detecting-fields'),
  };

  return kind ? titles[kind] : t('generating-action');
};

export default getJobTitle;
